import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import Icon from "../../assets/Icon";
import { Container } from './styles';

type Props = {
    onLeft?: () => void;
};

const ArrowLeft: React.FC<Props> = ({ onLeft }) => {
    const theme = useContext(ThemeContext);

    return (
        <Container onClick={onLeft}>
            <Icon icon={'Arrow_left'} size={50} color={theme.colors.background} />
        </Container>
    );
};

export default ArrowLeft;